import { render } from "./emailLogin.vue?vue&type=template&id=dfb7b15e&scoped=true&ts=true"
import script from "./emailLogin.vue?vue&type=script&lang=ts"
export * from "./emailLogin.vue?vue&type=script&lang=ts"

import "./emailLogin.vue?vue&type=style&index=0&id=dfb7b15e&scoped=true&lang=scss"

import exportComponent from "/home/build/jenkins/workdir/workspace/fast-build/fast-build/67161/vshow-main/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dfb7b15e"]])

export default __exports__